import { changeScreen } from '../global/changeScreen';
import { getPrize, getPrizeByCode } from '../global/getPrize';
import { initScratchcard } from '../global/scratchcard';
import { capiBasicEventAjax, capiGetCookie, capiGetEventID } from './conversions-api';
import { scrollToYPos } from './scrollHelpers';
import wpAjax from './axios';

const doFormSubmissionActions = async (form, data) => {
	if (
		data.status === 'error' ||
		data.status === 'under-eighteen' ||
		data.status === 'already-played'
	) {
		form.querySelector('.js-form-fields').remove();
		form.querySelector(`.js-form-messages .${data.status}`).classList.remove('hidden');
		form.classList.remove('is-faded');
		scrollToYPos(0, 0.2);
	}

	if (data.status === 'success') {
		// Set first name and ctcId to local storage
		localStorage.setItem('firstName', form.querySelector('#atreemo_fname').value);
		localStorage.setItem('email', form.querySelector('#atreemo_email').value);
		localStorage.setItem('ctcId', data.ctcId);

		// Do the prize draw...
		let prizeObj = getPrize();

		console.log('prizeobj', prizeObj);

		// Check if the prize is available
		try {
			const { data } = await wpAjax.post('', {
				action: 'ajax_is_prize_available',
				prizeCode: prizeObj.prize.prizeCode,
			});

			// If not available, set the prize to lose
			if (data != 'is-available') {
				prizeObj = getPrizeByCode('lose');
			}
		} catch (err) {
			console.log(err);
			prizeObj = getPrizeByCode('lose');
		}

		// console.log('final prize', prizeObj);

		initScratchcard(prizeObj.prize);

		// Go to the scratchcard screen
		setTimeout(() => {
			changeScreen('scratchcard');
			capiBasicEventAjax('game sign up');
			form.classList.remove('is-faded');
		}, 1000);
	}
};

const resetFormMessages = (form) => {
	form.querySelectorAll('.js-form-messages p').forEach((msg) => msg.classList.add('hidden'));
};

export { doFormSubmissionActions, resetFormMessages };
